import { cn } from 'noddi-ui-common';
import { NoddiBadge } from 'noddi-ui-web';
import type { MemberGroup } from './notificationGroupTypes';
import type { NotificationGroupOverviewTranslations } from './notificationTranslations';

type Props = {
  member: MemberGroup;
  translations: NotificationGroupOverviewTranslations;
};

export const DrivenCount = ({ member, translations: t }: Props) => {
  const drives = member.managedCarCount;
  const silenced = !member.smsBookingNotifications && !member.smsRecallProposals;

  return (
    <div className='flex min-w-0 flex-col gap-1'>
      <span className={cn('truncate', (silenced || drives === 0) && 'text-muted-foreground')}>
        {t.carCount(drives)}
      </span>
      {silenced && drives > 0 && (
        <NoddiBadge variant='warning' className='w-fit px-1.5 py-0 text-[10px]'>
          {t.smsTurnedOff}
        </NoddiBadge>
      )}
    </div>
  );
};
